import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function FormURL({ product, category, children }) {
  const params = {
    product: product,
    category: category,
  };
  const encodeParams = () =>
    Object.entries(params)
      .map((kv) => kv.map(encodeURIComponent).join('='))
      .join('&');

  useEffect(() => {}, [product, category]);

  return <a href={'/Forms?' + encodeParams()}>{children}</a>;
}

FormURL.propTypes = {
  product: PropTypes.string,
  category: PropTypes.string,
};

export { FormURL };
